import React, { useState } from "react";
import HomeHeader from "../home/HomeHeader";
import { queryTypes, useQueryState } from "next-usequerystate";
import LoginComponent from "../home/LoginComponent";
import SponsorsHero from "./SponsorsHero";
import FeaturesSection from "./FeaturesSection";
import SponsorsSecondaryFeatures from "./SponsorsSecondaryFeatures";
import BookDemoSection from "./BookDemoSection";
import MiniFeaturesSection from "./MiniFeaturesSection";
import SponsorsContacts from "./SponsorsContacts";
import SponsorsTestimonial from "./SponsorsTestimonial";
import features_1 from "public/marketing/sponsors/features/features_1.png";
import features_2 from "public/marketing/sponsors/features/features_2.png";
import features_3 from "public/marketing/sponsors/features/features_3.png";
import features_4 from "public/marketing/sponsors/features/features_4.png";
import list from "public/marketing/sponsors/accelerators/list.svg";
import chatGpt from "public/marketing/sponsors/accelerators/chat_gpt.svg";
import files from "public/marketing/sponsors/accelerators/files.svg";
import messages from "public/marketing/sponsors/accelerators/messages.svg";
import users from "public/marketing/sponsors/accelerators/users.svg";
import chartMixed from "public/marketing/sponsors/accelerators/chart_mixed.svg";

const FEATURES = [
  {
    title: "Create an instant online shareable pitch deck",
    description:
      "Create beautiful interactive deal pages. Let investors easily share your deal via their unique deal link, sending an email invite, or by connecting with their friends on Elmbase.",
    image: features_1,
  },
  {
    title: "Grow your network",
    description:
      "Any new investor that lands on your deal page automatically gets added to your address book. Tap into Elmbase's unique investor network, while keeping your investors confidential.",
    image: features_2,
  },
  {
    title: "Give investors kudos for making referrals",
    description:
      "Recognize your biggest supporters, and offer them early/exclusive/priority access to future deals.",
    image: features_3,
  },
  {
    title: "Leverage AI",
    description:
      "Give your investors a ChatGPT-powered chatbot to help them better understand your deal documents. Emphasize your tech savvy approach to deal-making.",
    image: features_4,
  },
];

const miniFeatures = [
  {
    title: "Showcase your track record",
    description: "Build trust and confidence with prospective investors.",
    image: list,
  },
  {
    title: "Give investors an AI assistant",
    description:
      "Investors can get their questions answered instantly, in natural language and backed with clickable references, from our ChatGPT-powered assistant.",
    image: chatGpt,
  },
  {
    title: "Let your deal go viral",
    description:
      "Let investors effortlessly share your deal with their unique link. Any new prospect is automatically tagged and added to your contact book.",
    image: files,
  },
  {
    title: "Secure deal room",
    description:
      "Eliminate ambiguity in the investment process. Give investors a private place to ask questions, understand their progress, and proceed with their investment.",
    image: messages,
  },
  {
    title: "Launch email campaigns",
    description:
      "Send mass emails and get detailed engagement statistics. Store an unlimited number of contacts and send as many emails as you'd like.",
    image: users,
  },
  {
    title: "Detailed engagement analytics",
    description:
      "Elmbase captures thousands of datapoints per deal, enabling you to know exactly which investors are genuinely interested and where to prioritize your efforts. ",
    image: chartMixed,
  },
];

const Sponsors = () => {
  const [showLoginUrl] = useQueryState("login", queryTypes.boolean);
  const [showLogin, setShowLogin] = useState(showLoginUrl);

  return (
    <div className="w-full bg-white">
      <LoginComponent show={showLogin} setShow={setShowLogin} />
      <HomeHeader setShow={setShowLogin} />
      <SponsorsHero />
      <SponsorsTestimonial />
      <FeaturesSection
        headerText={"Unlock your network's potential"}
        subtitleText={"Remove the friction from letting your deal go viral.*"}
        features={FEATURES}
        footerText={"* For 506c offerings."}
        linkId={"features"}
      />
      <SponsorsSecondaryFeatures />
      <BookDemoSection
        headerText={"Book a demo today"}
        subtitleText={"Discover what Elmbase can do for you."}
        showDemoButton={true}
      />
      <MiniFeaturesSection
        miniFeatures={miniFeatures}
        headerText={"Raise more, faster"}
        subtitleText={"Streamline the fragmented investment experience."}
        linkId={"subfeatures"}
      />
      <SponsorsContacts />
    </div>
  );
};

export default Sponsors;
